import $ from 'jquery';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ProductApp from './products/components/ProductApp';

$(document).ready(function() {
    // Sidebar toggle functionality
    $('.toggle-sidebar').on('click', function() {
        $('.intranet-sidebar').toggleClass('active');
    });

    // Mount React Product Filter App
    // The ProductApp component automatically restores filters from sessionStorage
    // when navigating back from product detail pages
    const productAppContainer = document.getElementById('product-filter-app');
    if (productAppContainer) {
        const root = createRoot(productAppContainer);
        root.render(<ProductApp />);
    }
});
